import { translationKey } from '../i18n';
import { localize } from '../i18n';
// Persist the pending intent before sending. A lost response must reuse the same request ID,
// even after navigation/reload. Successful new doses receive new IDs (including same-minute doses).
const inFlight = new Map();
const recoveredError = () => {
    const error = new Error(translationKey('이전 복용 기록의 저장을 확인했어요. 새 기록은 한 번 더 눌러주세요'));
    error.response = { data: { message: localize(error.message) } };
    error.prnRecovered = true;
    return error;
};
const requestId = () => globalThis.crypto?.randomUUID?.() || `prn-${Date.now()}-${Math.random().toString(36).slice(2)}`;
export function recordPrn(post, uuid, medicationId, takenAt = null) {
    const key = `prn_pending_v1:${uuid}:${medicationId}`;
    if (inFlight.has(key)) {
        const active = inFlight.get(key);
        return active.takenAt === takenAt ? active.promise : active.promise.then(() => { throw recoveredError(); });
    }
    const run = async () => {
        const previous = localStorage.getItem(key);
        const body = previous ? JSON.parse(previous) : { requestId: requestId(), takenAt };
        const serialized = JSON.stringify(body);
        localStorage.setItem(key, serialized);
        // Another browser context may own a newer intent by the time this request completes.
        const clearPending = () => { if (localStorage.getItem(key) === serialized) localStorage.removeItem(key); };
        let response;
        try {
            response = await post(body);
        } catch (error) {
            // Only payload validation rejection proves this intent was not committed.
            // Timeouts, disconnected responses and server errors remain retryable with the same ID.
            if ([400, 422].includes(error.response?.status)) clearPending();
            throw error;
        }
        clearPending();
        if (previous && body.takenAt !== takenAt) {
            throw recoveredError();
        }
        return response;
    };
    const pending = run().finally(() => inFlight.delete(key));
    inFlight.set(key, { takenAt, promise: pending });
    return pending;
}
